export default function LocationMap() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-12 space-y-4">
      <h1 className="text-3xl font-semibold tracking-tight">Location & Map</h1>
      <p className="text-muted-foreground">
        We are in Suan Pueng, Ratchaburi. Use the map to navigate.
      </p>
      <div className="aspect-[16/9] rounded-lg overflow-hidden border bg-muted">
        <iframe
          title="Map"
          className="w-full h-full"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=Suan%20Phueng%2C%20Ratchaburi&output=embed"
        />
      </div>
    </section>
  );
}
